import React, { Component } from 'react';
import { Modal, Button } from '@ezviz/ezd';
import './index.less';

class EnterpriseWeChat extends Component { // 企业微信弹窗
  constructor() {
    super();
    this.state = {
      visible: false
    }  
  }
  // 打开关闭弹窗  
  handleCancel = () => {
    this.setState({
      visible: !this.state.visible
    })
  }
  render() {
    const { visible } = this.state;
    
    const { children, title, weChatImg, weChatDesc,okText, modalZIndex } = this.props;
    return (
        <div>
          { this.props.text ?
          <div className={this.props.className} onClick={()=>{
            this.setState({
              visible: true
            })
            window.monitor && window.monitor.report({textKey: `website_fixbar_${this.props.ptype}`, text: this.props.textKeyTitle || this.props.title});
          }}>{this.props.text}</div>
          :
          <div onClick={()=>{
            this.setState({
              visible: true
            })
            window.monitor && window.monitor.report({textKey: `website_fixbar_${this.props.ptype}`, text: this.props.textKeyTitle || this.props.title});
          }}>
            {this.props.children}
          </div>
          }
          <Modal
            visible={visible}
            zIndex={modalZIndex}
            title={title ? title : '国标问题对接'}
            width={480}
            onCancel={this.handleCancel}
            getContainer={this.props.parentNode}
            footer={[
              <Button key="back" onClick={this.handleCancel} type="primary">
                {okText || '我知道了'}
              </Button>
            ]}
          >
            <div className="consult-modal-box">
                <img className="consult-modal-img" src={ weChatImg ? weChatImg : "https://resource.eziot.com/group2/M00/00/76/CtwQF2IgMDeAU3dmAABHHnm4jK8337.png" } />
                <div className="consult-modal-txt">{ weChatDesc ? weChatDesc : "国标对接专家，一对一解答 "} </div>
            </div>
          </Modal>
        </div>
    );
  }
}

export default EnterpriseWeChat;
